export const RESPONSE_VALIDATION_ERROR_TYPE = 'ResponseValidationError';

export default class ResponseValidationError extends Error {
  readonly type = RESPONSE_VALIDATION_ERROR_TYPE;

  constructor(message: string) {
    super(message);
    this.name = RESPONSE_VALIDATION_ERROR_TYPE;
  }
}
